export const levelZero = level => level === 0;

export const getSection = level => (levelZero(level) ? 'nav' : 'sub-nav');

export const getLinkNo = items =>
  items.reduce((n, { sub }) => {
    if (!sub) return n;
    return n + sub.length;
  }, items.length);
